(function() {
  // =======================
  // ★ 設定セクション
  // =======================
  var CONFIG = {
    LOAD_INTERVAL_MS: 200,       // 次のリモートロード開始までの間隔
    DOM_UPDATE_INTERVAL_MS: 1000, // DOM置き換え間隔（描画キュー）
  };

  // =======================
  // 内部状態
  // =======================
  var pendingUpdates = [];
  var updating       = false;

  // =======================
  // DOM更新キュー
  // =======================
  function enqueueDomUpdate(el, html) {
    pendingUpdates.push({ el: el, html: html });

    if (!updating) {
      processDomUpdateQueue();
    }
  }

  function processDomUpdateQueue() {
    if (pendingUpdates.length === 0) {
      updating = false;
      return;
    }

    updating = true;
    var item = pendingUpdates.shift();

    item.el.innerHTML = item.html;

    setTimeout(processDomUpdateQueue, CONFIG.DOM_UPDATE_INTERVAL_MS);
  }

  // =======================
  // リモート読込（1つ分）
  // =======================
  function loadRemoteIntoContainer(el) {
    // すでに読み込み済みならスキップ
    if (el.dataset.loaded === "true") {
      return Promise.resolve();
    }

    el.dataset.loaded = "true";

    // ローディング表示
    var loaders = el.querySelectorAll(".js-loadingStateText");
    loaders.forEach(function(cell) {
      cell.textContent = "🔄 Loading...";
    });

    var url = el.getAttribute("data-remote-url");
    if (!url) {
      return Promise.resolve();
    }

    return fetch(url, { headers: { "X-Requested-With": "XMLHttpRequest" } })
      .then(function(res) { return res.text(); })
      .then(function(html) {
        enqueueDomUpdate(el, html);
      })
      .catch(function(err) {
        console.error("load failed:", err);
      });
  }

  // =======================
  // 上から順番に全部ロード
  // =======================
  function initSequentialAutoLoad() {
    var elements = Array.prototype.slice.call(
      document.querySelectorAll(".js-autoLoadRemote")
    );
    if (elements.length === 0) return;

    var index = 0;

    function loadNext() {
      if (index >= elements.length) {
        return;
      }

      var el = elements[index++];
      loadRemoteIntoContainer(el)
        .then(function() {
          // 成功でも失敗でも、少し待ってから次をロード
          setTimeout(loadNext, CONFIG.LOAD_INTERVAL_MS);
        });
    }

    loadNext();
  }

  // =======================
  // デバイス判定して起動タイミング決定
  // =======================
  function bindAutoLoadWithDeviceCheck() {
    var detector = window.IthDeviceDetector;

    if (!detector) {
      console.warn("IthDeviceDetector がまだ無いので fallback で onload を使う");
      window.addEventListener("load", initSequentialAutoLoad);
      return;
    }

    var device  = detector.detectDevice();
    var browser = detector.detectBrowser();

    var isPcChrome = device === "pc" && browser === "chrome";

    if (isPcChrome) {
      document.addEventListener("DOMContentLoaded", initSequentialAutoLoad);
    } else {
      window.addEventListener("load", initSequentialAutoLoad);
    }
  }

  bindAutoLoadWithDeviceCheck();

  // fallback
  document.addEventListener("DOMContentLoaded", () => {
    const remoteLinks = Array.prototype.slice.call(
      document.querySelectorAll(".js-autoTriggerClick")
    );

    if (remoteLinks.length === 0) return;

    let index = 0;

    function clickNext() {
      const link = remoteLinks[index];
      if (link) {
        link.click();
        index += 1;
        setTimeout(clickNext, 1000);
      }
    }

    // 最初のクリック開始
    clickNext();
  });
})();
